import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "./utils/api";
import TemplatesPage from "./Templates";
import "./AdminPreview.css";

// Read-only preview of a template or a form, opened from dAdmin (usually in a
// frame). The link carries a signed token that expires; no dForms sign-in is
// needed and nothing can be filled in or saved.
export default function AdminPreview() {
    const { token } = useParams();
    const [meta, setMeta] = useState(null);
    const [error, setError] = useState("");
    const [pageIndex, setPageIndex] = useState(0);

    useEffect(() => {
        let cancelled = false;
        apiFetch(`/api/admin-preview/${token}`, { method: "GET" })
            .then(async (res) => {
                const data = await res.json().catch(() => ({}));
                if (cancelled) return;
                if (!res.ok) { setError(data.error || "This preview could not be opened."); return; }
                setMeta(data);
            })
            .catch(() => { if (!cancelled) setError("This preview could not be opened."); });
        return () => { cancelled = true; };
    }, [token]);

    if (error) {
        return (
            <div className="admin-preview admin-preview-message" role="alert">
                <p>{error}</p>
            </div>
        );
    }
    if (!meta) return <div className="admin-preview admin-preview-message"><p>Loading preview...</p></div>;

    const pages = meta.pages || [];
    const page = pages[pageIndex];
    return (
        <div className="admin-preview">
            <div className="admin-preview-bar">
                <div className="admin-preview-title">
                    <span className="admin-preview-kind">{meta.kind === "template" ? "Template preview" : "Form preview"}</span>
                    <strong>{meta.title}</strong>
                    <span className="admin-preview-note">Read-only</span>
                </div>
                {pages.length > 1 && (
                    <nav className="admin-preview-pages" aria-label="Pages">
                        <button type="button" onClick={() => setPageIndex(i => Math.max(0, i - 1))} disabled={pageIndex === 0} aria-label="Previous page">&lsaquo;</button>
                        {pages.map((p, i) => (
                            <button
                                type="button"
                                key={p.page_id}
                                className={i === pageIndex ? "active" : ""}
                                aria-current={i === pageIndex ? "page" : undefined}
                                onClick={() => setPageIndex(i)}
                            >
                                {p.page_title || `Page ${i + 1}`}
                            </button>
                        ))}
                        <button type="button" onClick={() => setPageIndex(i => Math.min(pages.length - 1, i + 1))} disabled={pageIndex === pages.length - 1} aria-label="Next page">&rsaquo;</button>
                    </nav>
                )}
            </div>
            {page ? (
                <div className="admin-preview-body">
                    <TemplatesPage key={page.page_id} formId={meta.id} pageId={page.page_id} previewToken={token} />
                </div>
            ) : (
                <div className="admin-preview-message"><p>This form has no pages yet.</p></div>
            )}
        </div>
    );
}
